import React, { useState, useImperativeHandle, Fragment } from 'react'
import { Checkbox, Modal, Button } from 'antd'
import intl from 'react-intl-universal'
import './index.scss'

export interface AgreementCheckboxRef {
  showAgreementModal: (callback: () => void) => void
}

const AgreementCheckbox = ({ ref, checked, onChange, onAgree }: {
  ref: React.RefObject<AgreementCheckboxRef>
  checked: boolean
  onChange: (checked: boolean) => void
  onAgree?: () => void
}) => {
  const [confirmModalVisible, setConfirmModalVisible] = useState(false)
  // 保存同意后需要执行的回调
  const [pendingCallback, setPendingCallback] = useState(null)

  // 点击协议链接
  const handleTermClick = (type) => {
    if (type === 'service') {
      window.open('https://yd-statics.oss-cn-beijing.aliyuncs.com/privacy/%E4%BA%91%E7%9B%AF%E7%94%A8%E6%88%B7%E6%9C%8D%E5%8A%A1%E5%8D%8F%E8%AE%AE.html', '_blank')
    } else {
      window.open('https://yd-statics.oss-cn-beijing.aliyuncs.com/privacy/%E7%BD%91%E9%A1%B5%E7%AB%AF%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96.html', '_blank')
    }
  }

  // 暴露给父组件的方法：弹出同意/不同意确认弹窗
  useImperativeHandle(ref, () => ({
    showAgreementModal (callback) {
      setPendingCallback(() => callback)
      setConfirmModalVisible(true)
    }
  }))

  // 用户点击"不同意"
  const handleDisagree = () => {
    setConfirmModalVisible(false)
    setPendingCallback(null)
  }

  // 用户点击"同意"
  const handleAgree = () => {
    setConfirmModalVisible(false)
    // 勾选复选框
    onChange && onChange(true)
    // 执行之前暂存的回调（登录或跳转流程）
    if (pendingCallback) {
      pendingCallback()
      setPendingCallback(null)
    }
  }

  return (
    <Fragment>
      <div className='agreement-checkbox'>
        <Checkbox checked={checked} onChange={(e) => onChange && onChange(e.target.checked)} />
        <span className='agreement-checkbox-text'>
          {intl.get('login.iHaveReadAndAgree')}
          <span className='agreement-checkbox-link' onClick={() => handleTermClick('service')}>{intl.get('login.userServiceAgreement')}</span>
          {intl.get('login.andText')}
          <span className='agreement-checkbox-link' onClick={() => handleTermClick('privacy')}>{intl.get('login.privacyPolicyText')}</span>
        </span>
      </div>

      {/* 登录前确认弹窗 */}
      <Modal
        className='agreement-confirm-modal'
        title={intl.get('login.serviceAgreementAndPrivacy')}
        open={confirmModalVisible}
        onCancel={handleDisagree}
        centered
        width={480}
        footer={
          <div className='agreement-confirm-footer'>
            <Button className='agreement-confirm-btn disagree' onClick={handleDisagree}>{intl.get('login.disagree')}</Button>
            <Button type='primary' className='agreement-confirm-btn agree' onClick={handleAgree}>{intl.get('login.agree')}</Button>
          </div>
        }
      >
        <div className='agreement-confirm-content'>
          {intl.get('login.pleaseReadAgreement')}
          <span className='agreement-checkbox-link' onClick={() => handleTermClick('service')}>{intl.get('login.userServiceAgreement')}</span>
          {intl.get('login.andText')}
          <span className='agreement-checkbox-link' onClick={() => handleTermClick('privacy')}>{intl.get('login.privacyPolicyText')}</span>
          {intl.get('login.continueUse')}
        </div>
      </Modal>
    </Fragment>
  )
}

export default AgreementCheckbox
